import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Tooltip as MaterialTooltip } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { StyledChildrenContainer } from "./styles";

const UnstyledClickToOpen = ({ className, children, ...tooltipProps }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleTooltipClose = () => {
        setIsOpen(false);
    };

    const handleTooltipOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <MaterialTooltip
                className={className}
                open={isOpen}
                onClose={handleTooltipClose}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                {...tooltipProps}
            >
                <StyledChildrenContainer
                    className={className}
                    onClick={handleTooltipOpen}
                >
                    {children}
                </StyledChildrenContainer>
            </MaterialTooltip>
        </ClickAwayListener>
    );
};

const ClickToOpen = styled(UnstyledClickToOpen)``;

ClickToOpen.propTypes = {
    children: PropTypes.any.isRequired
};

export default ClickToOpen;
